//
//
//
//
//



export default {
   components: {
  
  },
  name: 'figureSign',
}
